import React from 'react'

import InputErrorsBox from './InputErrorsBox';
import styles from "./BaseInput.module.sass";

export const InputStyles = {
  "Rounded": "Rounded",
  "Flat": "Flat"
}

export default ({ className = '', inputStyle = InputStyles.Rounded, errors, ...props }) => {
  return (
    <div className={`form-group ${styles.container}`}>
      <input {...props}
             className={`${className} ${styles.input} form-control ${inputStyle === InputStyles.Rounded ? styles.rounded : ''}`}/>
      <InputErrorsBox errors={errors}/>
    </div>
  )
}
